export default __webpack_public_path__ + "static/media/excel_black.488ba07d.svg";